<ion-header>
  <div class="constrained-content">
    <div class="flex-space-between" style="align-items: flex-start">
      <div style="padding: 0 18px">
        <h3>
          <ion-icon
            name="custom-bot"
            style="font-size: 1.8rem; margin-right: 5px"
          ></ion-icon
          >AI Agent Tester
        </h3>
        <p class="subtitle">
          Chat with your AI Agent to test responses and performance
        </p>
        <ion-segment *ngIf="isDev()" [(ngModel)]="selectedMode">
          <ion-segment-button
            *ngFor="let option of TESTING_MODES"
            [value]="option.value"
          >
            <ion-label>{{ option.label }}</ion-label>
          </ion-segment-button>
        </ion-segment>
      </div>
      <ion-button (click)="onDismissRunQueryModal()" fill="clear" color="dark">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </div>
  </div>
</ion-header>

<app-single-agent-tester *ngIf="selectedMode === 'SINGLE'" />
<app-agent-comparison-tester *ngIf="selectedMode === 'DOUBLE'" />
